Vue.component("order-summary",
    {
        template: "#vue-order-summary",

        data()
        {
            return {
                totals: {
                    priceGross: 0,
                    priceNet: 0,
                    currency: "",
                    vatAmount: 0,
                    vatValue: 0
                },
                contractDescription: "",
                billingVariant: "",
                billingVariantDesc: "",
                waitForResponse: false,
                openAdditionalCostsInfo: false
            };
        },

        computed: {
            ...Vuex.mapGetters(
                {
                    selectedContractId: "getSelectedContractId",
                    getInclusiveCount:  "getInclusiveCount",
                    isAdditionalItem:   "isAdditionalItem",
                    trans:              "getTranslation",
                    isFlexFeeItem:      "isFlexFeeItem",
                    isModuleItem:       "isModuleItem",
                    getPreparedContractByType: "getPreparedContractByType"
                }
            ),

            ...Vuex.mapState(
                {
                    pid:                  state => state.assistant.pid,
                    systemModuleList:     state => state.assistant.systemModuleList,
                    assistantModuleList:  state => state.assistant.assistantModuleList,
                    contact:              state => state.contact.contact,
                    newContact:           state => state.contact.newContact,
                    billingAddress:       state => state.contact.billingAddressData,
                    bankData:             state => state.contact.bankData,
                    paymentMethod:        state => state.contact.paymentMethod,
                    countryIsoCode:       state => state.contact.countryIsoCode,
                    countryName:          state => state.contact.countryName,
                    lang:                 state => state.localization.shopLanguage,
                    selectedContractType: state => state.assistant.selectedContractType,
                    selectedBiPlanItemId: state => state.assistant.selectedBiPlanItemId,
                    biPlanList:           state => state.assistant.biPlans,
                    contractList:         state => state.assistant.contractList,
                    contract(state)
                    {
                        return this.prepareContract(state.assistant.contract);
                    },
                    paymentMethodName(state)
                    {
                        return this.trans(state.contact.paymentMethod);
                    }
                }
            ),

            hasNewCurrency()
            {
                const contract = this.getPreparedContractByType(this.selectedContractType);

                if (contract)
                {
                    return this.totals.currency !== contract.data.price.currency.name;
                }
                return false;
            }
        },

        methods: {
            ...Vuex.mapMutations(
                [
                    "setBankData"
                ]
            ),

            ...Vuex.mapActions(
                [
                    "changePaymentMethod",
                    "createPaymentData",
                    "updateSystem",
                    "orderSystem",
                    "logout",
                    "saveContact",
                    "updateContactAddress"
                ]
            ),

            /**
             * Navigation between pages
             * @param direction 'next' || 'back'
             */
            navAction(direction)
            {
                this.$emit("nav-action", direction);
            },

            /**
             * On bank data change
             * @param field
             * @param event
             */
            onBankDataInputChange(field, event)
            {
                this.setBankData(
                    {
                        field: field,
                        value: event.target.value
                    });
            },

            /**
             * Prepare summary view
             * @param contract
             * @returns {contract|*}
             */
            prepareContract(contract)
            {
                const keys = Object.keys(contract);

                if (keys.length > 0)
                {
                    this.contractDescription = contract[keys[0]].data.texts.technicalData;
                    this.totals.vatValue = contract[keys[0]].data.price.vatValue;
                    this.totals.currency = contract[keys[0]].data.price.currency.name;

                    for (const item of Object.values(contract[keys[0]].data.children))
                    {
                        if (this.isFlexFeeItem(item.data.item.id))
                        {
                            this.billingVariant = item.data.texts.name1;
                            this.billingVariantDesc = item.data.texts.shortDescription;
                            break;
                        }
                    }

                    this.calculateTotalPrices(contract[keys[0]]);
                }
                return contract;
            },

            /**
             * Get contract term
             * @param properties
             * @returns {*}
             */
            getInterval(properties)
            {
                for (const property of properties)
                {
                    if (property.property.names.name === "Interval")
                    {
                        return this.trans(property.selection.name);
                    }
                }
                return this.trans("monthly");
            },

            /**
             * Calculate total base fee
             * @param contract
             */
            calculateTotalPrices(contract)
            {
                this.resetPrices();

                this.totals.priceGross += contract.data.price.price;
                this.totals.priceNet += contract.data.price.priceNet;

                const contractModules = contract.data.children;

                for (const module in contractModules)
                {
                    if (contractModules[module].data.quantity &&
                        parseInt(contractModules[module].data.quantity) > 0)
                    {
                        this.totals.priceGross +=
                            contractModules[module].data.price.price * parseInt(contractModules[module].data.quantity);

                        this.totals.priceNet +=
                            contractModules[module].data.price.priceNet * parseInt(contractModules[module].data.quantity);
                    }
                }
                this.totals.vatAmount = this.totals.priceGross - this.totals.priceNet;
            },

            getIncludedNum(item)
            {
                if (item.data.included)
                {
                    return item.data.included;
                }
                return this.getInclusiveCount(item);
            },

            /**
             *
             * @param item
             * @returns {*|boolean}
             */
            orderSummaryItemFilter(item)
            {
                return this.checkQuantity(item) && !this.isFlexFeeItem(item.$value.data.item.id);
            },

            /**
             * Filter if quantity is greater 0
             * @param item
             * @returns {boolean}
             */
            checkQuantity(item)
            {
                return parseInt(item.$value.data.quantity) > 0;
            },

            /**
             * Filter if included is greater 0
             * @param item
             * @returns {boolean}
             */
            includedItemFilter(item)
            {
                return parseInt(item.$value.data.included) > 0 || this.getInclusiveCount(item.$value) > 0;
            },

            /**
             * Filter if is a module item
             * @param module
             * @returns {*}
             */
            isModuleItemFilter(module)
            {
                return this.isModuleItem(module.$value);
            },

            /**
             * Validate bank data
             * @returns {boolean}
             */
            validateBankContactForm()
            {
                if (this.paymentMethod === 2)
                {
                    return true;
                }

                const form = document.querySelectorAll(".bank-contact-form")[0];

                if (!form.checkValidity())
                {
                    form.className += " was-validated";
                    return false;
                }

                form.className.replace(" was-validated", "");
                return true;
            },

            /**
             * Validate and save bank data, order on success
             */
            prepareOrder()
            {
                if (this.validateBankContactForm())
                {
                    this.waitForResponse = true;

                    if (!this.newContact)
                    {
                        this.createPaymentData().then(() =>
                        {
                            this.order();
                        });
                    }
                    else
                    {
                        this.saveContact().then(() =>
                        {
                            this.createPaymentData().then(() =>
                            {
                                this.order();
                            });
                        }, () =>
                        {
                            console.log("Something went wrong while registering you.");
                        });
                    }

                }
            },

            /**
             * Order or Update a contract
             */
            order()
            {
                if (this.pid > 0 && !this.newContact &&
                    Object.keys(this.systemModuleList).length > 0)
                {
                    this.updateSystem(this.contact.id)
                        .then(() =>
                        {
                            this.onSuccessContract();
                        });
                }
                else
                {
                    this.orderSystem(this.contact.id)
                        .then(() =>
                        {
                            this.fireGTag();
                            this.onSuccessContract();
                        });
                }
            },

            /**
             * Action after contract order/change
             */
            onSuccessContract()
            {
                if (this.newContact)
                {
                    this.logout();
                }

                this.waitForResponse = false;
                this.navAction("next");
            },

            /**
             * Set payment method
             * @param paymentMethod
             * @param toggle
             */
            setPaymentMethodChanged(paymentMethod, toggle)
            {
                this.changePaymentMethod(paymentMethod);
                $(document.getElementById("directDebitCollapse")).collapse(toggle);
            },

            /**
             * Reset calculated contract base fee
             */
            resetPrices()
            {
                this.totals.vatAmount = 0;
                this.totals.priceGross = 0;
                this.totals.priceNet = 0;
            },

            /**
             * Fires analytics event
             */
            fireGTag()
            {
                if (typeof window.gtag !== "undefined")
                {
                    window.gtag("event", "order", {
                        event_category: "Checkout: " + this.selectedContractType,
                        event_label: "plentymarkets orders"
                    });
                }
            },

            additionalCostItemsByContract(contractItem)
            {
                const childItems = Object.values(contractItem.data.children) || null;

                if (Array.isArray(childItems))
                {
                    return childItems.filter(item =>
                    {
                        const isPlentyBIModule = !!this.biPlanList[item.data.item.id];

                        return this.isAdditionalItem(item) && (!isPlentyBIModule || item.data.item.id === this.selectedBiPlanItemId);
                    }).sort((prev, next) =>
                    {
                        return next.data.variation.position - prev.data.variation.position;
                    });
                }

                return [];
            }
        }
    });
